module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Bold-acb6095a848c53a972422d0efd84b6bc.woff";